var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJunction = function SvgJunction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.6 24h-3.2v-6.4H8v-3.2h6.4V8h3.2v6.4H24v3.2h-6.4z",
    clipRule: "evenodd"
  })));
};
export { SvgJunction as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M17.6 24H14.4V17.6H8V14.4H14.4V8H17.6V14.4H24V17.6H17.6V24Z' fill='%234A6067'/%3e %3c/svg%3e";